import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import is from '../../_snowpack/pkg/styled-is.js';
import { colors } from './index.js';
const StyledCodeCard = styled.div.withConfig({
  displayName: "code-card__StyledCodeCard",
  componentId: "xkzvtb-0"
})(["flex:1 1 auto;background-color:#fff;border-radius:8px;box-shadow:0 1px 5px 0 rgba(0,0,0,0.08),0 2px 2px 0 rgba(0,0,0,0.08),0 3px 1px -2px rgba(0,0,0,0.08);padding:1rem;overflow-x:auto;width:min(400px,10vw);height:max-content;", " ", " ", " ", ""], is('marginTop')`
    margin-top: 1rem;
  `, is('marginRight')`
    margin-right: 1rem;
  `, is('marginBottom')`
    margin-bottom: 1rem;
  `, is('marginLeft')`
    margin-left: 1rem;
  `);
const Title = styled.h6.withConfig({
  displayName: "code-card__Title",
  componentId: "xkzvtb-1"
})(["margin:0 0 1rem;text-transform:uppercase;color:", ";"], colors.grey);

function CodeCard({
  title,
  children,
  margin
}) {
  const margins = { ...((margin === null || margin === void 0 ? void 0 : margin.includes('top')) && {
      marginTop: true
    }),
    ...((margin === null || margin === void 0 ? void 0 : margin.includes('right')) && {
      marginRight: true
    }),
    ...((margin === null || margin === void 0 ? void 0 : margin.includes('bottom')) && {
      marginBottom: true
    }),
    ...((margin === null || margin === void 0 ? void 0 : margin.includes('left')) && {
      marginLeft: true
    })
  };
  return /*#__PURE__*/React.createElement(StyledCodeCard, margins, /*#__PURE__*/React.createElement(Title, null, title), children);
}

const margins = PropTypes.oneOf(['top', 'right', 'bottom', 'left']);
CodeCard.propTypes = {
  margin: PropTypes.arrayOf(margins)
};
export { CodeCard };